import { render, staticRenderFns } from "./oxPay.vue?vue&type=template&id=1da1f80e&scoped=true"
import script from "./oxPay.vue?vue&type=script&lang=js"
export * from "./oxPay.vue?vue&type=script&lang=js"
import style0 from "./oxPay.vue?vue&type=style&index=0&id=1da1f80e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da1f80e",
  null
  
)

export default component.exports